import ArrowDownIcon from "@assets/icons/arrow-down.svg";
import ArrowUpIcon from "@assets/icons/arrow-up.svg";
import styled from "@emotion/styled";
import React from "react";
import { colors } from "@ui/style/colors";
import { SVGComponent } from "@typings/svg-component";
import { Button } from "primereact/button";
import { row } from "@ui/style";
import { isNotNil } from "@utils/assert";

interface StepperProps {
	iconUp?: SVGComponent;
	iconDown?: SVGComponent;
	onMoveUp?: () => void;
	onMoveDown?: () => void;
	min?: number;
	max?: number;
	value?: number;
	className?: string;
}

export const Stepper: React.FC<StepperProps> = ({
	iconUp: IconUp = ArrowUpIcon,
	iconDown: IconDown = ArrowDownIcon,
	onMoveUp,
	onMoveDown,
	min,
	max,
	value,
	className,
}) => {
	const isFirst = isNotNil(min) && isNotNil(value) && value <= min;
	const isLast = isNotNil(max) && isNotNil(value) && value >= max;

	return (
		<Container className={className}>
			<Button onClick={onMoveUp} disabled={isFirst}>
				<IconUp width={24} height={24} color={isFirst ? colors.grey50 : colors.grey} />
			</Button>
			<Separator />
			<Button onClick={onMoveDown} disabled={isLast}>
				<IconDown width={24} height={24} color={isLast ? colors.grey50 : colors.grey} />
			</Button>
		</Container>
	);
};

const Separator = styled.div`
	width: 1px;
	height: 100%;
	background-color: ${colors.neutral10};
`;

const Container = styled.div`
	${row(undefined, "center", "center")};
	width: 88px;
	height: 40px;
	border-radius: 30px;
	border: 1px solid ${colors.neutral10};
	overflow: hidden;

	> button {
		${row(undefined, "center", "center")};
		flex: 1;
		height: 100%;
		margin: 0;
		padding: 0;
		border: none;
		border-radius: 0;
		background-color: transparent;

		&:not(:disabled):hover {
			background-color: ${colors.grey10};
			cursor: pointer;
		}
	}
	.p-button:disabled {
		background-color: unset;
	}
`;
